export enum GameType {
    Physical = 'PHYSICAL',
    Virtual = 'VIRTUAL',
}
